(function(window)
{
	window.cjs = window.createjs;

	Function.prototype.bind = Function.prototype.bind || function(object)
	{
		var t = this;
		return function()
		{
			return t.apply(object, arguments);
		};
	};

	if (console === undefined || console.log === undefined)
	{
		console = {};
		console.log = function() {};
	}

	//Create namespace
	window.cm = {

		main: null,
		global: window,
		prefix: '',

		merge: function(original, extended)
		{
			for (var key in extended)
			{
				var ext = extended[key];
				if (
					typeof(ext) !== 'object' ||
					ext instanceof HTMLElement ||
					ext === null
				)
				{
					original[key] = ext;
				}
				else
				{
					if (!original[key] || typeof(original[key]) !== 'object')
					{
						original[key] = (ext instanceof Array) ? [] :
						{};
					}
					cm.merge(original[key], ext);
				}
			}
			return original;
		},

		getUrlVar: function(name)
		{
			var vars = {};
			window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value)
			{
				vars[key] = value;
			});
			return vars[name] || null;
		},

		// Pseudo-random uid.
	 	makeUID: function()
	 	{
			var d = new Date().getTime();
			var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c)
			{
				var r = (d + Math.random() * 16) % 16 | 0;
				d = Math.floor(d / 16);
				return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
			});
			return uuid;
		},

		// The exact same functionality as underscore.js' _.findWhere function -- without loading the entire library!!
		findWhere: function(list, properties)
		{
			var len = list.length;
			var obj;
			var isMatch;
			for (var i = 0; i < len; i++)
			{
				obj = list[i];
				isMatch = true;
				for (var thing in properties)
				{
					if (typeof obj[thing] === "undefined" || obj[thing] !== properties[thing])
					{
						isMatch = false;
						break;
					}
				}
				if (isMatch)
				{
					return obj;
				}
			}
			if (!isMatch)
			{
				return undefined;
			}
		},

		// The exact same functionality as underscore.js' _.where function -- without loading the entire library!!
		where: function(list, properties)
		{
			var len = list.length,
				obj,
				results = [];

			for (var i = 0; i < len; i++)
			{
				obj = list[i];
				isMatch = true;
				for (var thing in properties)
				{
					if (typeof obj[thing] === "undefined" || obj[thing] !== properties[thing])
					{
						isMatch = false;
						break;
					}
				}
				if (isMatch)
				{
					results.push(obj);
				}
			}

			if (results.length > 0)
			{
				return results;
			}
			else
			{
				return undefined;
			}
		}
	};

})(window);